/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import { Search, Activity } from "lucide-react";

import NAV from "../../pages/nav";

export default function NewsHero() {

    return (

        <>
            {/* Main Navigation */}

            {/*<NAV activetag="news" />*/}

            {/* Hero Section */}

            <section className="
                relative
                overflow-hidden
                border-b
                border-zinc-800
                bg-zinc-950
            ">

                {/* Background Glow */}

                <div className="
                    absolute
                    top-0
                    left-0
                    w-[350px]
                    h-[350px]
                    bg-emerald-500/10
                    blur-3xl
                    rounded-full
                    -translate-x-1/2
                    -translate-y-1/2
                " />

                <div className="
                    absolute
                    top-0
                    right-0
                    w-[300px]
                    h-[300px]
                    bg-cyan-500/10
                    blur-3xl
                    rounded-full
                    translate-x-1/2
                    -translate-y-1/2
                " />

                <div className="
                    relative
                    max-w-7xl
                    mx-auto
                    px-6
                    py-10
                ">

                    {/* Small Badge */}

                    <div className="
                        inline-flex
                        items-center
                        gap-2
                        px-3
                        py-1.5
                        rounded-full
                        border
                        border-emerald-500/20
                        bg-emerald-500/10
                        text-emerald-400
                        text-xs
                        font-semibold
                        mb-5
                    ">

                        <Activity size={14} />

                        LIVE MARKET COVERAGE

                    </div>

                    {/* Heading */}

                    <h1 className="
                        text-4xl
                        lg:text-5xl
                        font-black
                        tracking-tight
                        leading-tight
                        text-white
                        mb-4
                        max-w-4xl
                    ">

                        Market News &
                        <span className="
                            bg-gradient-to-r
                            from-emerald-400
                            via-cyan-400
                            to-blue-500
                            bg-clip-text
                            text-transparent
                        ">
                            {" "}Financial Intelligence
                        </span>

                    </h1>

                    {/* Description */}

                    <p className="
                        text-zinc-300
                        text-base
                        lg:text-lg
                        leading-relaxed
                        max-w-3xl
                        mb-8
                    ">

                        Real-time financial news, macro trends,
                        institutional flows, earnings coverage
                        and AI-driven market intelligence.

                    </p>

                    {/* Search */}

                    <div className="
                        relative
                        max-w-xl
                    ">

                        <Search
                            className="
                                absolute
                                left-4
                                top-1/2
                                -translate-y-1/2
                                text-zinc-500
                            "
                            size={18}
                        />

                        <input
                            type="text"
                            placeholder="Search market news..."
                            className="
                                w-full
                                h-12
                                bg-zinc-900/90
                                border
                                border-zinc-700
                                rounded-xl
                                pl-11
                                pr-4
                                text-white
                                placeholder-zinc-500
                                text-sm
                                focus:outline-none
                                focus:border-emerald-500
                                focus:ring-2
                                focus:ring-emerald-500/20
                                transition-all
                            "
                        />

                    </div>

                </div>

            </section>
        </>
    );
}
